// ─────────────────────────────────────────────────────────────────────────────
// import
// ─────────────────────────────────────────────────────────────────────────────

import styled from 'styled-components';

// ─────────────────────────────────────────────────────────────────────────────
// component
// ─────────────────────────────────────────────────────────────────────────────

export const Footer = styled.footer`
  display: grid;
  background: var(--color-fg);
  box-shadow: inset 0 2px hsla(var(--hsl-text), 0.05);
`;
